// szczegóły płatności

import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

import { IDashboardSettlementsListItem } from 'api/types';

import styles from 'theme/pages/Payments/components/Details/Details.module.scss';

// typ danych wejściowych
interface IProps {
  details: IDashboardSettlementsListItem;
}

const Details: FC<IProps> = ({ details }) => {
  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-components-Details')}>
      <div>
        <div className={styles.title}>
          <Trans>Szczegóły płatności</Trans>
        </div>
        <span className={styles.label}>
          <Trans>Nazwa banku</Trans>:
        </span>{' '}
        {details?.bank_account_information?.bank_name}
        <br />
        <span className={styles.label}>
          <Trans>Metoda płatności</Trans>:
        </span>{' '}
        {details?.bank_account_information?.payment_method_name}
        <br />
        <span className={styles.label}>
          <Trans>Numer konta</Trans>:
        </span>{' '}
        {details?.bank_account_information?.account_bank_number}
      </div>
    </div>
  );
};

export default Details;
